<template>
    <div class="select-container" :class="{open: isOpen, nobor: border==false}" v-on-clickaway="away">
        <div class="select-input">
            <span class="fa fa-angle-down"></span>
            <input type="text" class="form-control form-control-sm"
                :placeholder="place"
                v-model="keyWord"
                @focus="onFocus"
                @keyup="onKeyup"/>
        </div>
        <div class="select-dropdown vld-parent" ref="i200" style="min-height: 30px;">
            <table class="table-select">
                <tbody>
                    <tr v-for="(ret,index) in records" :key="index" @click="select(ret)">
                        <td>{{ret.Num}}</td>
                        <td>{{ret.Name}}</td>
                        <td>{{ret.AccountTypeName}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    import { mixin as clickaway } from 'vue-clickaway';
    export default {
        mixins: [ clickaway ],
        props: {
            value: {
                type: String,
                default: ''
            },
            border: {
                type: Boolean,
                default: true
            },
            clear: {
                type: Boolean,
                default: false
            },
            place: {
                type: String,
                default: ''
            },
            vStore: {
                type: Boolean,
                default: false
            }
        },
        data: function(){
            return {
                keyWord: this.value,
                isOpen: false,
                list: [],
                records: [],
                isShow: false,
                isStore: this.vStore
            }
        },
        methods: {
            toList(){
                var loading = this.$loading.show({
                    container: this.$refs.i200,
                    height: 25,
                    loader: 'dots'
                });
                var req = {
                    Text: this.keyWord,
                    Limit: 0
                };
                this.$api().post('accounting/accounts', req).then((res) => {
                    if(res.status == 200){
                        this.list = res.data.Data;
                        this.records = res.data.Data;
                        this.isShow = true;
                    }
                }).finally(function(){ loading.hide(); });
            },
            onFocus(){
                this.isOpen = true;
                if(this.isStore){
                    this.list = this.$store.state.accounts;
                    this.records = this.$store.state.accounts;
                }else{
                    if(!this.isShow){
                        this.toList();
                    }
                }
            },
            onKeyup(){
                var key = this.keyWord.toLowerCase();
                this.records = this.list.filter(item => {
                    return (item.Name.toLowerCase().includes(key) || item.Num.toLowerCase().includes(key));
                });
            },
            away() {
                this.isOpen = false;
            },
            select(item){
                if(!this.clear)
                    this.keyWord = item.Name;
                else
                    this.keyWord = '';
                this.isOpen = false;
                this.$emit('select', item);
            }
        },
        watch: {
            value(val){
                this.keyWord = val;
            },
            vStore(value){
                this.isStore = value;
            }
        }
    }
</script>
<style scoped>
    .select-container{
        position: relative;
    }
    .select-container .form-control{
        padding-right: 30px;
    }
    .select-container .fa-search {
        position: absolute;
        left: 10px;
        top: 8px;
        color: #737373;
    }
    .select-container .fa-angle-down{
        position: absolute;
        right: 10px;
        top: 8px;
        font-weight: 600;
    }
    .select-container .select-dropdown {
        position: absolute;
        max-height: 300px;
        border: 1px solid #e4e7ea;
        border-radius: 3px;
        display: none;
        width: 100%;
        background: #fff;
        overflow: auto;
    }
    .select-container.open .select-dropdown{
        display: block;
        margin-top: 2px;
        z-index: 10;
    }
    .select-container .table-select{
        width: 100%;
    }
    .select-container .table-select tbody tr td{
        padding: 3px 8px;
        border: none;
    }
    .select-container .table-select tbody tr:hover{
        background: #f2f2f2;
        cursor: pointer;
    }
    .select-container.nobor .form-control{
        border: none;
    }
</style>